import { render, staticRenderFns } from "./AnaliseCadastralBtn.vue?vue&type=template&id=3f5a4df4"
import script from "./AnaliseCadastralBtn.vue?vue&type=script&lang=js"
export * from "./AnaliseCadastralBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports